import React from 'react';

const PageTitle = ({ titleContent, titleClass, titleDescription }) => (
	<div>
		<p
			className={`my-4 w-full whitespace-pre-wrap text-sfi-blue text-xl md:text-4xl text-left md:text-left font-semibold md:font-normal ${titleClass || ''}`}
		>
			{titleContent}
		</p>
		{titleDescription && (
			<div className="text-xs md:text-xl mb-4">{titleDescription}</div>
		)}
	</div>
);

export default PageTitle;
